<script lang="ts">
    import { SvelteToast, type SvelteToastOptions } from '@zerodevx/svelte-toast';

    export let options: SvelteToastOptions = {
        theme: {
            '--toastWidth': 'min(22.75rem, calc(100vw - 2rem))',
            '--toastBackground': 'transparent',
            '--toastMargin': '0',
            '--toastProgressBackground': '#C7C9D1',
            '--toastBarHeight': '0.25rem',
            '--toastBarBottom': '0.0625rem',
            '--toastPadding': 0,
            '--toastMsgPadding': 0,
            '--toastColor': 'currentColor',
            '--toastBoxShadow': 'none',
            '--toastBorderRadius': '0.75rem',
            '--toastMinHeight': 'auto',
        },
        intro: { y: -64 },
    };
</script>

<div class="svelte-toast-wrapper">
    <SvelteToast {options} />
</div>
<div class="svelte-toast-bottom-right-wrapper">
    <SvelteToast target="bottom-right" {options} />
</div>

<style lang="postcss">
    .svelte-toast-wrapper {
        --toastContainerTop: 1.75rem;
        --toastContainerRight: auto;
        --toastContainerBottom: auto;
        --toastContainerLeft: 50%;
    }

    .svelte-toast-bottom-right-wrapper {
        --toastContainerTop: auto;
        --toastContainerRight: 1.75rem;
        --toastContainerBottom: 1.75rem;
        --toastContainerLeft: auto;
    }

    :global(.svelte-toast-wrapper ._toastContainer) {
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        padding-top: 0.5rem;
    }

    :global(.svelte-toast-wrapper ._toastContainer > li) {
        position: relative;
        z-index: 1;
    }

    :global(.svelte-toast-wrapper ._toastContainer > li[style*='position: absolute']) {
        z-index: 0;
    }

    :global(.svelte-toast-bottom-right-wrapper ._toastContainer) {
        display: flex;
        flex-direction: column-reverse;
        gap: 0.5rem;
        padding-bottom: 0.5rem;
    }

    :global(.svelte-toast-bottom-right-wrapper ._toastContainer > li) {
        position: relative;
        z-index: 1;
    }

    :global(._toastItem) {
        overflow: visible !important;
        will-change: transform !important;
    }
</style>
